module.exports = __webpack_public_path__ + "img/logo_swift.78225897.png";